import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { validateEmptyFields } from '../../helpers/util'
import InputTextFieldGrid from '../common/InputTextFieldGrid'
import BackButton from '../BackButton'
import InputSelectFieldGrid from '../common/InputSelectFieldGrid'
import { getOperatorsService } from 'services/admin/operatorServices'
import { errorAlert } from 'helpers/alerts'
import CustomButton from 'components/CustomButton'

const CarrierForm = ({ title, goBack, defaultValues, submit, validate }) => {
  const { control, handleSubmit } = useForm({ defaultValues });
  const watch = useWatch({ control });
  const [disabled, setDisabled] = useState(true);
  const [operators, setOperators] = useState([])

  useEffect(() => {
    getOperatorsService().then((result) => {
      setOperators(result);
    }
    ).catch((e) => {
      errorAlert(e);
    }
    )
    // eslint-disable-next-line
  }, [watch]);
  useEffect(() => {
    setDisabled(validateEmptyFields(watch, { validate }));
    // eslint-disable-next-line
  }, [watch]);

  return (
    <>
      <BackButton name={title} click={goBack} />
      <Grid container direction="column" justifyContent="center" alignItems="center" >
        <Grid container direction="column" m={"40px"} maxWidth={"40%"} justifyContent="center" alignItems="center" spacing={3}>
          <InputTextFieldGrid
            name="name"
            label="Nombre"
            required="Debes agregar el nombre"
            control={control}
          />
          <InputSelectFieldGrid
            name={"operadora"}
            xs={6}
            control={control}
            required={"Debes seleccionar una operadora"}
            label={"Seleccionar operadora"}
            data={operators}
            formatter={(data) =>
              data?.map(({ id, name }) => ({ id: id, name: name }))
            }
          />
          <InputTextFieldGrid
            name="carrier_id"
            label="Carrier Id"
            required="Debes agregar el carrier id"
            control={control}
          />
        </Grid>
        <Grid item justifyContent="center" alignItems="center" >
          <CustomButton
            click={handleSubmit(submit)}
            name={"Guardar"}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default CarrierForm